export const iframeId = 'cld-media-editor-iframe';
